(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bonn-floating-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {   
    
    //clear floating-menu
    document.querySelector('.floating-menu').innerHTML = '';
    const floatingMenu = document.querySelector('.floating-menu');
    document.querySelector('#MainContent').style.marginLeft = `18%`;    
    
    const sections = document.querySelectorAll('.floating-menu-item');
    sections.forEach((section, index) => {
      const item = document.createElement('div');
      item.classList.add('floating-menu__item');
      const link = document.createElement('a');
      link.classList.add('floating-menu__link');
      link.href = `#${section.parentElement.id}`;
      link.textContent = section.textContent;
      item.appendChild(link);
      floatingMenu.appendChild(item);
    });
    let l = document.getElementsByClassName(`anchor`)[0].getBoundingClientRect().x - document.getElementsByClassName(`floating-menu`)[0].getBoundingClientRect().width - 40;
    floatingMenu.style.left = `${l}px`;
    calculateNewPosition();
    floatingMenu.addEventListener('click', function(event) {
        // const items = document.querySelectorAll('.floating-menu__item');
        // items.forEach(item => {
        //     item.classList.remove('active');
        // });
        // event.target.parentElement.classList.add('active');
        //add smooth transition

    });
    document.getElementById('accordion').addEventListener('click', function() {
        var menuItems = document.querySelector('.floating-menu');

        menuItems.classList.toggle('active');
    });
    document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
          //cancel scroll event 
          if (
            location.pathname.replace(/^\//, '') == anchor.pathname.replace(/^\//, '') && 
            location.hostname == anchor.hostname
            ) {
            
            var target = document.querySelector(anchor.hash);
            target = target ? target : document.querySelector('[name=' + anchor.hash.slice(1) + ']');
            if (target) {
                event.preventDefault();
                //add active class to the item
                const items = document.querySelectorAll('.floating-menu__item');
                items.forEach(item => {
                    item.classList.remove('active');
                });
                anchor.parentElement.classList.add('active');

                window.scrollTo({
                    top: target.offsetTop -120,
                    behavior: 'smooth'
                });
                
            }
          }
        });
        });
        return false
  });


window.addEventListener('resize', function() {
    calculateNewPosition();
});
window.addEventListener('scroll', function() {
    calculateNewPosition();
    //when the scroll pass close to item menu floating add active class to the item
    //validate is no after click on the item

    // const items = document.querySelectorAll('.floating-menu__item');
    // items.forEach(item => {
    //     const section = document.querySelector(item.querySelector('a').hash);
    //     const rect = section.getBoundingClientRect();
    //     console.log(rect.top, rect.bottom)
    //     if (rect.top <= 100 && rect.bottom >= 100) {
    //         items.forEach(item => {
    //             item.classList.remove('active');
    //         });
    //         item.classList.add('active');
    //     }
    // });

});
//match the floating menu with the anchor position with observer patter 

function calculateNewPosition(){
    //validate screen size 
    if(window.innerWidth < 1110){
        //add new classname to .floating-menu 
        document.querySelector('.floating-menu').classList.add('floating-menu-mobile');
        document.querySelector('.floating-menu').style = '';
        document.querySelector('#MainContent').style.marginLeft = ``;    
        document.querySelector('#MainContent').style.margin = `2rem`;
        return;
    }else{
        //remove new classname to .floating-menu 
        document.querySelector('.floating-menu').classList.remove('floating-menu-mobile');
        document.querySelector('#MainContent').style.marginLeft = `18%`;  
    }

    const floatingMenu = document.querySelector('.floating-menu');
    const firstAnchor = document.querySelector('.anchor');
    const lastAnchor = document.querySelector('.anchor:last-child');
    
    const floatingNew = getPosition(floatingMenu)
    const firstAnchorNew = getPosition(firstAnchor)

    
    //calculate distance between floatingmenu and footer 
    const footer = document.querySelector('.footer');
    const footerNew = getPosition(footer)
    const diferent = footerNew.top - floatingNew.bottom;
    
    if(firstAnchorNew.top > floatingNew.top && diferent > 360){
        console.log('one')
        const mainContent = document.querySelector('#MainContent')
        mainContent.style.position = 'relative'
        floatingMenu.style.position = 'absolute'  
        floatingMenu.style.transition = 'bottom 0.7s'
        
        //calculate left with absolute position with relative parent 
        // Calculate the left position with absolute position and relative parent
        const parentOffsetLeft = mainContent.getBoundingClientRect().left
        const anchorOffsetLeft = document.querySelector('.anchor').getBoundingClientRect().left
        const floatingMenuWidth = floatingMenu.getBoundingClientRect().width

        const l = anchorOffsetLeft - parentOffsetLeft - floatingMenuWidth - 40

        floatingMenu.style.left = `${l}px`
        
        // floatingMenu.style.top = `210px`;
        floatingMenu.style.top = `5%`
    }
    if(floatingNew.top < 0){
        console.log('two')
        document.querySelector('#MainContent').style.position = `initial`
        //add smooth transition
        floatingMenu.style.transition = `top 0.7s`
        floatingMenu.style.position = `fixed`
        let l = document.getElementsByClassName(`anchor`)[0].getBoundingClientRect().x - document.getElementsByClassName(`floating-menu`)[0].getBoundingClientRect().width - 40
        floatingMenu.style.left = `${l}px`
       
        floatingMenu.style.top = `50%`
    }    
    
    
}

function getPosition(element) {
    var clientRect = element.getBoundingClientRect();
    return {
            left: clientRect.left,
            top: clientRect.top ,
            bottom: clientRect.bottom
        };
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
